import {
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

const SubServicesCard = ({ data }) => {
  const currentLanguage = useSelector(
    (state) => state.languageReducer.currentLanguage
  );
  const { name, description, image } = data || {};
  return (
    <Grid item xs={12} sm={6} md={4} key={data._id} display={"flex"}>
      <Card sx={{ maxWidth: 345 }}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="160"
            image={image}
            alt={name[currentLanguage]}
            style={{
              objectFit: "fill",
            }}
            sx={{
              "&.MuiCardMedia-media": {
                objectFit: "fill",
              },
            }}
          />
          <CardContent>
            <Typography
              textTransform={"capitalize"}
              gutterBottom
              variant="h6"
              component="div"
            >
              {name[currentLanguage]}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {description[currentLanguage]}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

export default SubServicesCard;
